// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var ChevronUp = React.forwardRef(function ChevronUp(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ChevronUp" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 7L19 14.1611L17.2024 16L12 10.6779L6.79759 16L5 14.1611L12 7Z", fill: "currentColor" }))));
});
ChevronUp.displayName = 'ChevronUp';
export default ChevronUp;
//# sourceMappingURL=ChevronUp.js.map